import { render, staticRenderFns } from "./Vahvista.vue?vue&type=template&id=6e84e414&"
import script from "./Vahvista.vue?vue&type=script&lang=js&"
export * from "./Vahvista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Vahvista.vue"
export default component.exports